import { DuplicateCopiesFields } from 'modules/campaigns/modules/campaigns-group-form/components/DuplicateCopiesFields/DuplicateCopiesFields';
import {
    COMMON_FLAGS,
    FEATURE_FLAGS,
    useCommonConfig,
    useConfigMatch,
} from 'modules/taboola-common-frontend-modules/account-configurations';

export const DuplicateCampaignCopiesField = () => {
    const { [COMMON_FLAGS.DUPLICATE_CAMPAIGNS_MAX_COPIES]: maxCopies } = useCommonConfig([
        COMMON_FLAGS.DUPLICATE_CAMPAIGNS_MAX_COPIES,
    ]);

    const isDuplicateCopiesFieldEnabled = useConfigMatch({
        [FEATURE_FLAGS.DUPLICATE_CAMPAIGNS_COPIES_FIELD_ENABLED]: 'true',
    });

    if (!isDuplicateCopiesFieldEnabled) {
        return null;
    }

    return <DuplicateCopiesFields maxCopies={maxCopies} field="duplicateCampaignSettings.numberOfCopies" />;
};
